import { render, staticRenderFns } from "./ResourceList.vue?vue&type=template&id=20a52fca&scoped=true&"
import script from "./ResourceList.vue?vue&type=script&lang=js&"
export * from "./ResourceList.vue?vue&type=script&lang=js&"
import style0 from "./ResourceList.vue?vue&type=style&index=0&id=20a52fca&prod&scoped=true&lang=css&"
import style1 from "./ResourceList.vue?vue&type=style&index=1&id=20a52fca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a52fca",
  null
  
)

export default component.exports